import { useCreateMachine } from 'fsm';
import { PropertyDefinitionsContext } from './context';
import { machine } from './machine';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyDefinitionsProvider = ({
  objectTypeId,
  children
}) => {
  const propertyDefinitionsMachine = useCreateMachine(machine, {
    initialContext: {
      propertyDefinitions: [],
      objectTypeId
    }
  });
  return /*#__PURE__*/_jsx(PropertyDefinitionsContext.Provider, {
    value: propertyDefinitionsMachine,
    children: children
  });
};